function isTouchDevice() {
  try {
    return window ? "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 : false;
  } catch (e) {
    console.error("Check device failed: ", e);
    return false;
  }
}
export {
  isTouchDevice as default
};
